import { pipe, Either, Task } from "fp";

import { type, creator, reducer, effects } from "~/Action";
import * as Data from "~/Data";
import * as Messaging from "~/Messaging";

export namespace Requested {
  export const { TYPE, create, reduce } = pipe(
    type("Driver Messages requested" as const),
    creator((driver: Data.Reference.Reference) => ({ driver })),
    reducer(
      ({ state }) =>
        (state.messages.store = Data.Store.requested(state.messages.store))
    ),
    effects(({ dispatch, action: { driver }, state: { context, companies } }) =>
      pipe(
        Messaging.Request.Get.request({ ...companies.current, driver })(
          context
        ),
        Task.map((result) => dispatch(Received.create(result)))
      )()
    )
  );
}

export namespace Received {
  export const { TYPE, create, reduce } = pipe(
    type("Driver Messages received" as const),
    creator(
      (
        result?: Either<Error, Data.Cache.Cache<readonly Messaging.Message[]>>
      ) => ({ result })
    ),
    reducer(
      ({ state, action: { result } }) =>
        (state.messages.store = Data.Store.received(result)(
          state.messages.store
        ) as typeof state.messages.store)
    )
  );
}
